/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Stage_ScrapeInputs */

const en_directory_submit_enrich_stage_scrape = /** @type {(inputs: Directory_Submit_Enrich_Stage_ScrapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch pages`)
};

const zh_directory_submit_enrich_stage_scrape = /** @type {(inputs: Directory_Submit_Enrich_Stage_ScrapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抓取网页`)
};

/**
* | output |
* | --- |
* | "Fetch pages" |
*
* @param {Directory_Submit_Enrich_Stage_ScrapeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_stage_scrape = /** @type {((inputs?: Directory_Submit_Enrich_Stage_ScrapeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Stage_ScrapeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_stage_scrape(inputs)
	return zh_directory_submit_enrich_stage_scrape(inputs)
});
export { directory_submit_enrich_stage_scrape as "directory.submit.enrich.stage.scrape" }